import dayjs from 'dayjs'

export const TODAY_DATE = dayjs().format('YYYY-MM-DD')

export const APPOINTMENT_STATUS_ENUM = {
    CALLED_CLIENT: 'called_client',
    WAITING_PARTNER: 'waiting_partner',
    IN_QUEUE: 'in_queue',
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
}
